import { dynamicApiSlice } from "../dynamicApi";
import { buildODataQuery } from "@/helpers";
import type {
  ODataResponse,
  WorkflowStepInstanceOutputReasonList,
} from "@/types";

export const workflowStepInstanceOutputReasonsApi =
  dynamicApiSlice.injectEndpoints({
    endpoints: (builder) => ({
      getWorkflowStepInstanceOutputReasons: builder.query<
        WorkflowStepInstanceOutputReasonList,
        {
          filter?: string;
          select?: string[];
          expand?: string;
          orderBy?: string;
          top?: number;
          skip?: number;
        }
      >({
        query: (params) =>
          `WorkflowStepInstanceOutputReasons?${buildODataQuery(params)}`,
        transformResponse: (
          response: ODataResponse<WorkflowStepInstanceOutputReasonList>,
        ) => response.value,
      }),
    }),
    overrideExisting: false,
  });

export const { useGetWorkflowStepInstanceOutputReasonsQuery } =
  workflowStepInstanceOutputReasonsApi;
